export const staticStates = {
  activity: [
    // Colors values here are AntD color codes https://4x.ant.design/docs/spec/colors
    // The render is different than CSS colors https://www.w3schools.com/cssref/css_colors.php
    { key: "deleted", color: "red" },
    { key: "created", color: "green" },
    { key: "updated", color: "blue" },
    { key: "restored", color: "magenta" },
  ],
  recommendation: [
    { key: "missing" },
    { key: "not_required" },
    { key: "in_progress" },
    { key: "completed" },
  ],
} as const;
